
$(document).ready(function() {

	const boxesAudioTemplate = {
        isLoading: false,
        init() {
            $('.audio-player').each(function(index, item) {
                var id = $(item).data('id');
                var mid = $(item).data('mid');
                let media;
        
                $(item).mediaelementplayer({
                    features: ['current', 'progress', 'duration','volume'],
                    pauseOtherPlayers: false,
                    // audioWidth: 300,
                    // audioHeight: 25
                    iconSprite: './assets/vendor/mediaelementjs/mejs-controls.svg',
                    startVolume: .4,
                    // hideVolumeOnTouchDevices: false,
                    success: function (mediaElement, domObject) {
                        media = mediaElement; // make it available for other functions
                    }
                });
        
                $( "#audio-player-btn-play-"+mid+"-" + id).on( "click", function() {
                    $( this ).toggleClass( "active" );
                    $( this ).siblings().toggleClass( "active" );
                    media.play();
                } );
            
                $( "#audio-player-btn-pause-"+mid+"-" + id).on( "click", function() {
                    $( this ).toggleClass( "active" );
                    $( this ).siblings().toggleClass( "active" );
                    media.pause();
                } );
            });
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

		}
    };

    if ($('.boxes-audio-template').length) {
        boxesAudioTemplate.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/boxes-audio.js